import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import authService from "./authServices";

const getUserfromLocalStorage = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;
const initialState = {
  user: getUserfromLocalStorage,
  orders: [],
  cards: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  userUpdated: false,
  loggedFlag: false,
  cart: [],
  message: "",
  wishlist: [],
};

export const signup = createAsyncThunk(
  "auth/sign-up",
  async (userData, thunkAPI) => {
    try {
      return await authService.signup(userData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async (userData, thunkAPI) => {
    try {
      return await authService.login(userData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const updateProfile = createAsyncThunk(
  "auth/edit-profile",
  async (data, thunkAPI) => {
    console.log(data.dob);
    try {
      const formData = new FormData();
      formData.append("fullName", data.fullName);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("dob", data.dob);
      formData.append("image", data.image);
      return await authService.editProfile(formData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const userCart = createAsyncThunk(
  "cart/store-cart",
  async (data, thunkAPI) => {
    try {
      return await authService.userCart(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getOrders = createAsyncThunk(
  "user/get-orders",
  async (thunkAPI) => {
    try {
      return await authService.getOrders();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCards = createAsyncThunk("user/get-cards", async (thunkAPI) => {
  try {
    return await authService.getCards();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getWishList = createAsyncThunk(
  "user/get-wishlist",
  async (thunkAPI) => {
    try {
      return await authService.getWishList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_Auth_State");
export const resetUpdatedFlag = createAction("Reset_Updated_Flag");
export const resetLoggedInFlag = createAction("Reset_LoggedIn_Flag");
export const logout = createAction("auth/logout");
export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {},
  extraReducers: (buildeer) => {
    buildeer
      .addCase(signup.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(signup.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.loggedFlag = true;
        state.message = "success";
      })
      .addCase(signup.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
        state.isLoading = false;
      })
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.loggedFlag = true;
        state.user = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
        state.isLoading = false;
      })
      .addCase(updateProfile.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        if (action.payload) {
          const updatedState = { ...action.payload, token: state.user.token };
          let existingData = JSON.parse(localStorage.getItem("user"));
          existingData = updatedState;
          localStorage.setItem("user", JSON.stringify(existingData));
          state.user = updatedState;
        }
        state.userUpdated = true;
        state.message = "success";
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(userCart.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(userCart.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.cart = action.payload;
      })
      .addCase(userCart.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(getOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.orders = action.payload;
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(getCards.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCards.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.cards = action.payload;
      })
      .addCase(getCards.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(getWishList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getWishList.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.wishlist = action.payload;
      })
      .addCase(getWishList.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(resetState, () => initialState)
      .addCase(resetUpdatedFlag, (state, action) => {
        state.userUpdated = false;
      })
      .addCase(resetLoggedInFlag, (state, action) => {
        state.loggedFlag = false;
      })

      .addCase(logout, (state, action) => {
        // Reset the state to its initial values
        localStorage.removeItem("user");
        return {
          ...initialState,
          user: null,
        };
      });
  },
});

export default authSlice.reducer;
